import{Box as e,createPolymorphicComponent as t}from"@mantine/core";import{forwardRef as x}from"react";import{jsx as f}from"@emotion/react/jsx-runtime";var o=x((r,p)=>f(e,{...r,ref:p}));o.displayName="Box";var B=t(o),m=B;export{m as Box};
